module.exports = __webpack_public_path__ + "media/click.589ef5a8.mp3";